import styles from './Sizes.module.scss';

export const RIGHT_PANEL_WIDTH = parseInt(styles.rightPanelWidth, 10);
const SIDEBAR_WIDTH = parseInt(styles.sidebarWidth, 10);

const Sizes = {
  SM: 'sm',
  MD: 'md',
  LG: 'lg',
} as const;

export type Size = typeof Sizes[keyof typeof Sizes];

export enum LayoutSize {
  mobile = 'mobile',
  tablet = 'tablet',
  desktop = 'desktop',
  largeDesktop = 'largeDesktop',
}

export const LAYOUT_MIN_MAX_WIDTHS: Record<LayoutSize, [number, number]> = {
  [LayoutSize.mobile]: [0, 655],
  [LayoutSize.tablet]: [655, 916],
  [LayoutSize.desktop]: [916, 1920],
  [LayoutSize.largeDesktop]: [1920, Number.MAX_SAFE_INTEGER],
};

const DESKTOP_MIN_WIDTH = LAYOUT_MIN_MAX_WIDTHS[LayoutSize.desktop][0];
export const SIDEBAR_SHIFT_BREAKPOINT = DESKTOP_MIN_WIDTH + SIDEBAR_WIDTH;
export const RIGHT_PANEL_SHIFT_BREAKPOINT =
  DESKTOP_MIN_WIDTH + RIGHT_PANEL_WIDTH;

export default Sizes;
